import { Component, OnInit } from '@angular/core'
import { FormFieldFactoryComponentAbstract } from '../../core/component/form-field-factory/form-field-factory.component-abstract'

@Component({
    selector: 'mga-form-factory-field-number',
    templateUrl: './form-factory-field-number.component.html',
    styleUrls: ['./form-factory-field-number.component.scss'],
})
export class FormFactoryFieldNumberComponent extends FormFieldFactoryComponentAbstract {}
